import React from "react";
import SampleForm from "./SampleForm";
import OurRoute from "./OurRoute";
import JourneyMap from "./JourneyMap";
import TruckArtBand from "./TruckArtBand";
import OilWave from "./OilWave";
import { Droplet, Heart, Instagram, Facebook, Music2 } from "lucide-react";

const HAIR_DRIPS_LOGO = "/scene/hairdrips_logo.png";
const BOTTLE_IMG = "/scene/bottle.png";

export default function HairDripsLanding() {
  return (
    <main className="relative min-h-screen overflow-hidden bg-[#fff8f0]" data-testid="landing-root">
      {/* Top truck-art band */}
      <TruckArtBand height="h-6 sm:h-8" />

      {/* HEADER LOGO — big Hair Drips script logo, centered */}
      <header className="relative pt-10 sm:pt-14 pb-2 flex flex-col items-center">
        <img
          src={HAIR_DRIPS_LOGO}
          alt="Hair Drips"
          className="w-56 sm:w-72 lg:w-80 h-auto drop-shadow-[0_6px_14px_rgba(229,25,127,0.12)]"
          data-testid="brand-logo"
          draggable={false}
        />
        <div className="mt-6 flex items-center gap-3 text-[#e5197f]">
          <span className="h-px w-12 bg-[#e5197f]/50" />
          <span className="font-display tracking-[0.4em] text-xs sm:text-sm">
            ROUTES TO ROOTS
          </span>
          <span className="h-px w-12 bg-[#e5197f]/50" />
        </div>
      </header>

      {/* HERO — centered LAUNCHING SOON, form, bottle floats right */}
      <section id="top" className="relative max-w-6xl mx-auto px-4 sm:px-8 pt-10 pb-12">
        <div className="text-center max-w-2xl mx-auto relative z-10">
          <h1 className="relative inline-block font-display text-[#e5197f] leading-[0.95] text-5xl sm:text-6xl lg:text-7xl">
            LAUNCHING SOON
            <span className="inline-block text-[#e5197f] -ml-1">!</span>
            <span aria-hidden="true" className="absolute -top-3 -right-7 sm:-right-10">
              <svg width="38" height="38" viewBox="0 0 60 60" className="text-[#f26b1e]">
                <g stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                  <line x1="30" y1="4" x2="30" y2="18" />
                  <line x1="44" y1="14" x2="52" y2="6" />
                  <line x1="14" y1="14" x2="6" y2="6" />
                  <line x1="46" y1="30" x2="56" y2="30" />
                  <line x1="40" y1="44" x2="50" y2="50" />
                </g>
              </svg>
            </span>
          </h1>

          <h2 className="mt-4 font-display font-bold tracking-[0.02em] text-[#0b1b3d] text-sm sm:text-base lg:text-lg whitespace-nowrap">
            HERITAGE HAIRCARE MADE WITH LOVE
            <Heart className="inline-block w-4 h-4 ml-2 align-baseline text-[#e5197f]" fill="#e5197f" />
          </h2>

          <div className="mt-5 flex items-center gap-3 justify-center">
            <span className="h-px w-16 bg-[#e5197f]/30" />
            <Droplet className="w-4 h-4 text-[#f26b1e]" fill="#f26b1e" />
            <span className="h-px w-16 bg-[#e5197f]/30" />
          </div>

          <p className="mt-4 text-[#0b1b3d]/85 text-lg italic">
            Nourishment that flows. Rooted in tradition.
          </p>
          <p className="mt-2 text-[#e5197f] text-base">
            Be the first to know when we Launch <br />
            Sign-up for FREE Samples!
          </p>

          <div className="mt-6 max-w-xl mx-auto">
            <SampleForm />
          </div>
        </div>

        {/* Bottle floats to the right edge */}
        <div
          className="hidden lg:block absolute right-4 xl:right-8 bottom-6 z-0 pointer-events-none"
          data-testid="hero-bottle"
          aria-hidden="true"
        >
          <img
            src={BOTTLE_IMG}
            alt=""
            className="w-[200px] xl:w-[230px] h-auto drop-shadow-[0_22px_38px_rgba(11,27,61,0.32)] select-none"
            draggable={false}
          />
        </div>

        {/* Bottle on small/medium screens — below form */}
        <div className="lg:hidden mt-10 flex justify-center" data-testid="hero-bottle-mobile">
          <img
            src={BOTTLE_IMG}
            alt="Hair Drips Daily Drip hair oil bottle"
            className="w-[45%] max-w-[220px] h-auto drop-shadow-[0_18px_30px_rgba(11,27,61,0.3)] select-none"
            draggable={false}
          />
        </div>
      </section>

      {/* OUR ROUTE — 3-pin animated driving map */}
      <OurRoute />

      {/* THE JOURNEY — landmark Silk Road map (Pakistan → Macclesfield) */}
      <section className="relative max-w-6xl mx-auto px-4 sm:px-8 pb-12" data-testid="the-journey">
        <div className="flex items-center justify-center gap-3 text-[#f26b1e]">
          <span className="h-px w-10 bg-[#f26b1e]/40" />
          <h2 className="font-display tracking-[0.4em] text-sm sm:text-base">THE JOURNEY</h2>
          <span className="h-px w-10 bg-[#f26b1e]/40" />
        </div>
        <p className="mt-3 text-center text-[#0b1b3d]/75 max-w-xl mx-auto">
          From the silk roads of{" "}
          <span className="text-[#e5197f] font-bold">Pakistan</span> to the silk town of{" "}
          <span className="text-[#f26b1e] font-bold">Macclesfield</span> — every drop has a story.
        </p>
        <div className="mt-6">
          <JourneyMap />
        </div>
      </section>

      {/* FOOTER — FOLLOW OUR JOURNEY above the gold streak */}
      <footer className="relative mt-6" data-testid="site-footer">
        {/* Follow our journey + social icons (above the gold streak, no overlap) */}
        <div className="bg-[#fff8f0] pt-8 pb-6 text-center">
          <p className="font-display tracking-[0.35em] text-sm sm:text-base text-[#0b1b3d]">
            FOLLOW OUR JOURNEY
          </p>
          <div className="mt-4 flex items-center justify-center gap-3">
            <a aria-label="Instagram" href="https://www.instagram.com/hairdripsuk?utm_source=qr" target="_blank" rel="noopener noreferrer" data-testid="social-instagram"
               className="w-10 h-10 rounded-full bg-[#e5197f] hover:bg-[#c4156c] flex items-center justify-center text-white shadow-[0_6px_18px_-4px_rgba(229,25,127,0.6)] transition-transform hover:-translate-y-0.5">
              <Instagram className="w-5 h-5" />
            </a>
            <a aria-label="Facebook" href="https://www.facebook.com/share/19GogcGuxt/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" data-testid="social-facebook"
               className="w-10 h-10 rounded-full bg-[#e5197f] hover:bg-[#c4156c] flex items-center justify-center text-white shadow-[0_6px_18px_-4px_rgba(229,25,127,0.6)] transition-transform hover:-translate-y-0.5">
              <Facebook className="w-5 h-5" />
            </a>
            <a aria-label="TikTok" href="https://www.tiktok.com/@hairdripsuk?_r=1&_t=ZN-98p2pYfiTaw" target="_blank" rel="noopener noreferrer" data-testid="social-tiktok"
               className="w-10 h-10 rounded-full bg-[#e5197f] hover:bg-[#c4156c] flex items-center justify-center text-white shadow-[0_6px_18px_-4px_rgba(229,25,127,0.6)] transition-transform hover:-translate-y-0.5">
              <Music2 className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Gold oil streak — now un-obscured */}
        <OilWave />

        <div className="bg-[#fff8f0] py-5 text-center">
          <p className="text-xs tracking-[0.3em] text-[#0b1b3d]/55">
            HAIR DRIPS · ROOTED IN HERITAGE
          </p>
        </div>
        {/* Bottom truck-art band */}
        <TruckArtBand height="h-6 sm:h-8" />
      </footer>
    </main>
  );
}
